import * as THREE from 'three'

import { create_conteiner_picture_from_cargo_area_cuboid } from './cargoAreaImageConteiner'
import { create_RGB_axes_helper_with_symbols } from './cargoAreaRGBHelper'

export function cargo_area_adding(
  cargoAreaProp,
  cargo_area_group,
  group_of_cargo_area_attribute,
  group_of_cargo_area_floor,
  camera,
  controls,
  cameraState
) {
  cargo_area_group.clear()
  group_of_cargo_area_floor.clear()
  group_of_cargo_area_attribute.clear()

  const width = Number(cargoAreaProp[0].widthX)
  const height = Number(cargoAreaProp[0].heightY)
  const depth = Number(cargoAreaProp[0].depthZ)
  const x = Number(cargoAreaProp[0].x)
  const y = Number(cargoAreaProp[0].y)
  const z = Number(cargoAreaProp[0].z)



  const area = new THREE.Box3()
  area.setFromCenterAndSize(
    new THREE.Vector3(width / 2, height / 2, depth / 2), // Center position
    new THREE.Vector3(width, height, depth) // Size
  )
  const cargo_area = new THREE.Box3Helper(area, 0xdf9707)
  cargo_area_group.add(cargo_area)

  //Create/adding transparent yellow floor for reading mouse moving position
  let floorGeometry = new THREE.BoxGeometry(width, 0, depth) // 1mm thick floor
  let floorMaterial = new THREE.MeshBasicMaterial({ 
    color: 0xffff00,
    transparent: true,
    opacity: 0.3 // how transparent
  })
  let cargo_area_floor = new THREE.Mesh(floorGeometry, floorMaterial)

  cargo_area_floor.position.set(width / 2, 0, depth / 2) // Y=0.5 to account for 1mm thickness
  cargo_area_floor.userData.isFloor = true
  group_of_cargo_area_floor.add(cargo_area_floor)

  //Creating RGB helper and picture of container.
  let cube = {
    width_X: width,
    height_Y: height,
    depth_Z: depth,
    x:x,
    y:y,
    z:z
  }

  create_conteiner_picture_from_cargo_area_cuboid(
    cube,
    group_of_cargo_area_attribute
  )
  create_RGB_axes_helper_with_symbols(width, height, depth, group_of_cargo_area_attribute)

  if (!cameraState) {
    // Position camera based on the largest dimension
    const maxDimension = Math.max(width, height, depth)
    camera.position.set(
      width + maxDimension * 0.5, 
      height + maxDimension * 0.5, 
      depth + maxDimension * 0.5
    )
  }

  controls.target.set(width / 2, height / 2, depth / 2)
  controls.update()

  return cargo_area
}
